import {
  ARGOS_EVENTS_TYPES_REQUEST, ARGOS_EVENTS_TYPES_SUCCESS, ARGOS_EVENTS_TYPES_FAIL,
  ARGOS_LOCKS_REQUEST, ARGOS_LOCKS_SUCCESS, ARGOS_LOCKS_FAIL,
  ARGOS_EVENTS_REQUEST, ARGOS_EVENTS_SUCCESS, ARGOS_EVENTS_FAIL
} from 'src/store/actions/argosEventsActions';

const initialState = {
  fetching: false, // argos events
  fetchingArgosEventTypes: false,
  fetchingArgosLocks: false,
  report: [],
  eventTypes: [],
  eventTypesOptions: [],
  locks: [],
  locksOptions: []
};

const arrayToOptions = (types) => types.map(({ Id, Name }) => ({ label: Name, value: `${Id}` }));

const argosEventsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ARGOS_EVENTS_TYPES_REQUEST: {
      return { ...state, fetchingArgosEventTypes: true };
    }
    case ARGOS_EVENTS_TYPES_SUCCESS: {
      return {
        ...state, eventTypes: action.types, eventTypesOptions: arrayToOptions(action.types), fetchingArgosEventTypes: false
      };
    }
    case ARGOS_EVENTS_TYPES_FAIL: {
      return { ...state, fetchingArgosEventTypes: false };
    }
    case ARGOS_LOCKS_REQUEST: {
      return { ...state, fetchingArgosLocks: true };
    }
    case ARGOS_LOCKS_SUCCESS: {
      return {
        ...state, locks: action.locks, locksOptions: arrayToOptions(action.locks), fetchingArgosLocks: false
      };
    }
    case ARGOS_LOCKS_FAIL: {
      return { ...state, fetchingArgosLocks: false };
    }
    case ARGOS_EVENTS_REQUEST: {
      return { ...state, fetching: true };
    }
    case ARGOS_EVENTS_SUCCESS: {
      return { ...state, fetching: false, report: action.report };
    }
    case ARGOS_EVENTS_FAIL: {
      return { ...state, fetching: false };
    }
    default: return state;
  }
};

export default argosEventsReducer;
